var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.current,{tag:"component",staticClass:"trend-tag",attrs:{"close":_vm.close,"color":_vm.color,"icon-style":_vm.iconStyle,"label":_vm.label,"small":_vm.small,"styles":_vm.styles,"target":_vm.target,"to":_vm.to,"macrotrend":_vm.macrotrend},on:{"click":_vm.onClick,"click:close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }